import { render, staticRenderFns } from "./umkmupload-v2.vue?vue&type=template&id=c0ee3d5c&scoped=true&"
var script = {}
import style0 from "./umkmupload-v2.vue?vue&type=style&index=0&id=c0ee3d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ee3d5c",
  null
  
)

export default component.exports